import { render, staticRenderFns } from "./ResourcesManager.vue?vue&type=template&id=0a6fb79c&scoped=true&"
import script from "./ResourcesManager.vue?vue&type=script&lang=js&"
export * from "./ResourcesManager.vue?vue&type=script&lang=js&"
import style0 from "./ResourcesManager.vue?vue&type=style&index=0&id=0a6fb79c&lang=scss&scoped=true&"
import style1 from "./ResourcesManager.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6fb79c",
  null
  
)

export default component.exports